import Cookies from 'js-cookie';
import { FREE_SHIPPING_THRESHOLD_CURRENCY } from '@/constants/shipping/shipping';

import type { Currency } from '@/constants/currency/currency';
import type { Cookie } from '@/models/browser/cookie';

/**
 * Function to set the cart session key
 * Saves the session key to both cookies and closure-based storage
 */
export const setCartSessionKey = ({ name, value }: Required<Cookie>) => {
  const newSessionKey = `${name}=${value}`;
  Cookies.set(name, value, {
    expires: 30,
  });
  return newSessionKey;
};

type GetAmountToFreeShippingArgs = {
  currency: Currency;
  currentPrice: number;
};

export const getAmountToFreeShipping = ({ currency, currentPrice }: GetAmountToFreeShippingArgs) => {
  const amountPrice = FREE_SHIPPING_THRESHOLD_CURRENCY[currency] - currentPrice;

  if (amountPrice > 0) {
    return amountPrice;
  }
  return 0;
};
